import { FC } from 'react';
import { useMethods } from '@lhb/hook';
import { postMessageToParent } from 'src/common/utils/ways';
import { getLcnPlaceListDetail } from 'src/views/lcn/pages/sitemap/api';
import styles from './index.module.less';
import Title from './Title';
import Container from 'src/common/components/Container/index';
import AddressRow from './AddressRow';
import PlaceOverview from './PlaceOverview';
import SpotList from './SpotList';

/**
 * @Description 列表项
 */
const ListItem: FC<{
  mapIns?,
  listRef?,
  style?,
  item?,
  index?,
  listData?,
  setItemData?,
  needFitView?,
  cityProvinceInfo?,
  isBatchCollect?,
  batchCollectIds?,
  setBatchCollectIds?,
  placeDetail,
  /** 从外部传入是因为当前组件无法记录状态 */
  setPlaceDetail,
}> = ({
  mapIns,
  listRef,
  style,
  item,
  index,
  listData, // 列表数据
  setItemData,
  needFitView = true, // 市场容量下不需要为false，其他默认true
  cityProvinceInfo, // 左上角选中的省市数据
  isBatchCollect, // 是否是批量收藏状态
  batchCollectIds, // 批量收藏的开店区域ids
  setBatchCollectIds, // 设置批量收藏的开店区域ids
  placeDetail,
  setPlaceDetail,
}) => {

  const methods = useMethods({

    /** 切换展开项 */
    changeExpand(expand: boolean) {
      if (expand) {
        getLcnPlaceListDetail({ id: item.id }).then((placeDetail) => {
          setPlaceDetail((val) => ({
            ...val,
            ...(placeDetail || {}),
            id: item.id
          }));
        });
      }
    },

    viewDetail: (e) => {
      e.stopPropagation();
      methods.placeDetail(placeDetail.tntPlaceId);
    },

    // 场地详情（在 LCN 的内嵌 iframe 生效）
    placeDetail(id) {
      console.log('placeDetail', id);
      id && postMessageToParent({ type: 'placeDetail', data: id }, '*');
    },

  });

  return <div className={styles.wrapperCon} style={style}>
    <div className={styles.itemCon}>
      {
        item && Object.entries(item)?.length ? <>
          {/* 标题行 */}
          <Title
            mapIns={mapIns}
            listRef={listRef}
            index={index}
            item={item}
            listData={listData}
            setItemData={setItemData}
            needFitView={needFitView}
            cityProvinceInfo={cityProvinceInfo}
            isBatchCollect={isBatchCollect}
            batchCollectIds={batchCollectIds}
            setBatchCollectIds={setBatchCollectIds}
            changeExpand={methods.changeExpand}
          />
          {
            item?.isFrontEndExpanded
              ? <div
                className={styles.listItemContent}
                onClick={(e) => methods.viewDetail(e)}>
                <Container
                  style={{ height: '100%' }}
                  top={<div className='mb-12'>
                    {/* 地址行 */}
                    <AddressRow address={placeDetail.address} className='mt-6' />
                    <PlaceOverview data={placeDetail || {}} className='mt-5'/>
                  </div>}
                >
                  <SpotList placeId={item.id} />
                </Container>
              </div> : <></>
          }
        </> : <div></div>
      }
    </div>
  </div>;
};

export default ListItem;
